import { __decorate } from "tslib";
import { attr, html, nullableNumberConverter } from '@microsoft/fast-element';
import { FoundationElement } from '@microsoft/fast-foundation';
import { ChameleonElementMixin } from '../../common/mixin';
const MIN_WIDTH = 56;
export const popoverContentV2Template = html `<template role="${(x) => x.role}" tabindex="0"
  ><slot></slot
></template>`;
export class PopoverContentV2Component extends ChameleonElementMixin(FoundationElement) {
    get role() {
        return this.hasAttribute('is-tooltip') ? 'tooltip' : 'dialog';
    }
    constructor() {
        super();
        this.inactive = true;
        this.compact = false;
        this.inverted = false;
        this.hidden = false;
        this.arrow = false;
        this.menu = false;
        this.large = false;
        this.isTooltip = false;
        this.handleMutation = (mutationsList) => {
            var _a;
            for (const mutation of mutationsList) {
                if (this.$fastController.isConnected && (mutation.type === 'childList' || mutation.type === 'characterData')) {
                    (_a = this.popoverEl) === null || _a === void 0 ? void 0 : _a.positionPopover();
                }
            }
        };
        this.contentObserver = new MutationObserver(this.handleMutation);
    }
    connectedCallback() {
        super.connectedCallback();
        this.contentObserver.observe(this, { childList: true, subtree: true });
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.contentObserver.disconnect();
    }
    zIndexChanged(_, next) {
        if (next) {
            this.style.setProperty('--z-index', next.toString());
        }
    }
    widthChanged(_, next) {
        if (next && next > MIN_WIDTH) {
            this.style.setProperty('--content-width', next.toString() + 'px');
        }
    }
    maxWidthChanged(_, next) {
        if (next) {
            this.style.setProperty('--max-width', next.toString() + 'px');
        }
    }
    minWidthChanged(_, next) {
        if (next) {
            this.style.setProperty('--min-width', next.toString() + 'px');
        }
    }
}
__decorate([
    attr({ mode: 'boolean' })
], PopoverContentV2Component.prototype, "inactive", void 0);
__decorate([
    attr({ mode: 'boolean' })
], PopoverContentV2Component.prototype, "compact", void 0);
__decorate([
    attr({ mode: 'boolean' })
], PopoverContentV2Component.prototype, "inverted", void 0);
__decorate([
    attr({ mode: 'boolean' })
], PopoverContentV2Component.prototype, "hidden", void 0);
__decorate([
    attr({ mode: 'boolean' })
], PopoverContentV2Component.prototype, "arrow", void 0);
__decorate([
    attr({ mode: 'boolean' })
], PopoverContentV2Component.prototype, "menu", void 0);
__decorate([
    attr({ mode: 'boolean' })
], PopoverContentV2Component.prototype, "large", void 0);
__decorate([
    attr()
], PopoverContentV2Component.prototype, "position", void 0);
__decorate([
    attr({ attribute: 'trigger' })
], PopoverContentV2Component.prototype, "trigger", void 0);
__decorate([
    attr({ attribute: 'z-index', converter: nullableNumberConverter })
], PopoverContentV2Component.prototype, "zIndex", void 0);
__decorate([
    attr({ attribute: 'is-tooltip' })
], PopoverContentV2Component.prototype, "isTooltip", void 0);
__decorate([
    attr({ converter: nullableNumberConverter })
], PopoverContentV2Component.prototype, "width", void 0);
__decorate([
    attr({ attribute: 'min-width', converter: nullableNumberConverter })
], PopoverContentV2Component.prototype, "minWidth", void 0);
__decorate([
    attr({ attribute: 'max-width', converter: nullableNumberConverter })
], PopoverContentV2Component.prototype, "maxWidth", void 0);
